/*
 Controller for the storefront for the merchant
 (At some point this will need to be on a per-outlet basis).
 */
angular.module('qkr').controller('accountancyController', ($scope, $rootScope, $routeSegment,
    inventoryService, merchantService, reportService, gettextCatalog, messageService) => {
    $scope.$routeSegment = $routeSegment; // Used to know what we've selected

    $scope.loading = true;

	$scope.accountancySettingsForm = {};
	$scope.showCustomerAccountNumber = false;

    $scope.showAccountancyCodesInReport = false;

    $scope.query = '';
    $scope.overTheCounterItems = [];
    $scope.invoiceItems = [];
    $scope.foodItems = [];
    $scope.uncategorizedItems = [];
    $scope.updatedItems = [];

    $scope.init = function() {
        $scope.$routeSegment = $routeSegment;

        inventoryService.loadInventory().then((promise) => {
            $scope.overTheCounterItems = [];
            $scope.invoiceItems = [];
            $scope.foodItems = [];
            $scope.uncategorizedItems = [];
            for (let i = 0; i < promise.length; ++i) {
                const item = promise[i];
                if (item.accType == 'OVER_THE_COUNTER') {
                    $scope.overTheCounterItems.push(item);
                } else if (item.accType == 'INVOICE') {
                    $scope.invoiceItems.push(item);
                } else if (item.accType == 'FOOD') {
                    $scope.foodItems.push(item);
                } else {
                    $scope.uncategorizedItems.push(item);
                }
            }
            $rootScope.undefinedProducts = $scope.uncategorizedItems.length;
        });

        merchantService.refreshMerchantInfo().then((promise) => {
            $scope.accountancySettingsForm.billerCode = promise.options.billerCode;
            $scope.showCustomerAccountNumber = reportService.isSynergeticType(promise.accountancyPackage.name);
            $scope.accountancySettingsForm.customerAccountNumber = promise.options.customerAccountNumber;
            $scope.accountancySettingsForm.showAccountancyCodesInReport = promise.options.showAccountancyCodesInReport;
            $scope.loading = false;
        });
    };

    $scope.setOverTheCounter = function(item) {
        item.accType = 'OVER_THE_COUNTER';
        item.accTypeDisplay = gettextCatalog.getString('Over the Counter');
        $scope.updatedItems.push(item);
    };

    $scope.setFood = function(item) {
        item.accType = 'FOOD';
        item.accTypeDisplay = gettextCatalog.getString('Food');
        $scope.updatedItems.push(item);
    };

    $scope.setInvoice = function(item) {
        item.accType = 'INVOICE';
        item.accTypeDisplay = gettextCatalog.getString('Invoice');
        $scope.updatedItems.push(item);
    };

    $scope.updateSettings = function() {
        merchantService.updateAccountancySettings($scope.accountancySettingsForm).then((promise) => {
            $scope.init();
            messageService.saveAlert();
        });
    };

    $scope.saveChanges = function() {
        inventoryService.saveAccountancyChanges($scope.uncategorizedItems).then((promise) => {
            inventoryService.updateAccTypes($scope.updatedItems).then((promise) => {
                $scope.init(); // Reconstruct the items lists
                messageService.saveAlert();
            });
        });
    };

    $scope.saveAccountancyChanges = function(items) {
        inventoryService.saveAccountancyChanges(items).then((promise) => {
            inventoryService.invalidateCache();
            inventoryService.loadInventory().then((data) => {
                $rootScope.$broadcast('newProducts', data);
                $scope.init(); // Reconstruct the items lists
            });
            messageService.saveAlert();
        });
    };

    $scope.resetToUnCategorized = function(item) {
        inventoryService.resetToUnCategorized(item).then((promise) => {
            inventoryService.invalidateCache();
            inventoryService.loadInventory().then((data) => {
                $rootScope.$broadcast('newProducts', data);
                $scope.init(); // Reconstruct the items lists
            });
            messageService.saveAlert();
        });
    };
});



// WEBPACK FOOTER //
// ./src/controllers/accountancy.controller.js